'use es6';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getTrack, trackIsLoading } from '../../selectors/trackSelectors';
import TrackIntroductionInformationContainer from './TrackIntroductionInformationContainer';
import TrackCompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackCompleteInterstitial';
import TrackIncompleteInterstitial from '../../components/ContentInterstitials/PostTrackInterstitial/TrackIncompleteInterstitial';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import { useAssetStatus } from '../../features/userProgress';
import { FILTER_CONSTS } from '../../constants/TopFilterConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackFinishedPageContainer = ({
  trackId
}) => {
  const track = useSelector(state => getTrack(state, {
    trackId
  }));
  const trackLoading = useSelector(state => trackIsLoading(state, {
    trackId
  }));
  const {
    status,
    allProgressLoading
  } = useAssetStatus({
    id: Number(trackId),
    type: 'TRACK'
  });
  const trackIsComplete = status === FILTER_CONSTS.STATUSES.COMPLETED;
  const isLoading = trackLoading || allProgressLoading;
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.CONCLUSION,
      trackId,
      trackIsComplete
    });
  }, [trackId, trackIsComplete]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 200
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [trackIsComplete ? /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_COMPLETE_VIEW_LOADED",
      children: /*#__PURE__*/_jsx(TrackCompleteInterstitial, {
        toRecommendations: true,
        trackId: trackId
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "COURSE_CONCLUSION_INCOMPLETE_VIEW_LOADED",
        children: /*#__PURE__*/_jsx(TrackIncompleteInterstitial, {
          toRecommendations: true,
          trackId: trackId
        })
      }), /*#__PURE__*/_jsx(TrackIntroductionInformationContainer, {
        track: track
      })]
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_CONCLUSION_VIEW_LOADED"
    })]
  });
};
TrackFinishedPageContainer.propTypes = {
  trackId: PropTypes.string
};
export default TrackFinishedPageContainer;